import { Link } from "react-router-dom";

export default function RefundPolicy() {
    return (
        <main className="container-page py-16 max-w-3xl fade-up" data-testid="refund-page">
            <p className="label-eyebrow mb-2">Refund policy</p>
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-6" style={{ fontFamily: "Outfit" }}>
                A straightforward promise.
            </h1>
            <p className="text-lg text-[#515B57] mb-10">
                Reading is a hard journey. If Lift Up Reading isn't the right tool for you, we don't want to keep your money.
            </p>

            <section className="card-rw p-8 mb-6">
                <h2 className="text-xl font-medium mb-3" style={{ fontFamily: "Outfit" }}>7-day full refund</h2>
                <p className="text-[#515B57] leading-relaxed">
                    If you subscribe and change your mind for any reason within <strong className="text-[#1C2321]">7 days</strong> of your first
                    payment, we'll refund you in full. No forms. No questions. Just email <a href="mailto:instructor@liftupreading.com" className="text-[#2D5D4E] underline">instructor@liftupreading.com</a> from the same address you signed up with and we'll process it within two business days.
                </p>
            </section>

            <section className="card-rw p-8 mb-6">
                <h2 className="text-xl font-medium mb-3" style={{ fontFamily: "Outfit" }}>Cancel anytime</h2>
                <p className="text-[#515B57] leading-relaxed">
                    You can cancel your subscription at any time from your account. You keep access until the end of the current billing period, and you're never charged again after that. We don't lock anyone in.
                </p>
            </section>

            <section className="card-rw p-8 mb-6">
                <h2 className="text-xl font-medium mb-3" style={{ fontFamily: "Outfit" }}>Yearly plans</h2>
                <p className="text-[#515B57] leading-relaxed">
                    For the yearly plan, the 7-day window still applies from the day you first paid. After 7 days, if you cancel a yearly plan mid-year we can offer a <strong className="text-[#1C2321]">pro-rated refund for the months you haven't used</strong>. Reach out and we'll sort it out.
                </p>
            </section>

            <section className="card-rw p-8 mb-10">
                <h2 className="text-xl font-medium mb-3" style={{ fontFamily: "Outfit" }}>Free trial</h2>
                <p className="text-[#515B57] leading-relaxed">
                    Every new learner gets 3 days of full access, no card required. If you don't subscribe by the end of the trial, you keep your account and can browse the app — you just won't be able to start new lessons or games until you subscribe.
                </p>
            </section>

            <p className="text-center">
                <Link to="/pricing" className="text-[#2D5D4E] font-medium hover:underline" data-testid="back-to-pricing">← Back to pricing</Link>
            </p>
        </main>
    );
}
